import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const GridPreferencePanelContext = /*#__PURE__*/React.createContext(undefined);
export function useGridPreferencePanelContext() {
  const context = React.useContext(GridPreferencePanelContext);
  if (context === undefined) {
    throw new Error('MUI X: Missing context.');
  }
  return context;
}
export function GridPreferencePanelContextProvider({
  children
}) {
  const columnsPanelTriggerRef = React.useRef(null);
  const filterPanelTriggerRef = React.useRef(null);
  const value = React.useMemo(() => ({
    columnsPanelTriggerRef,
    filterPanelTriggerRef
  }), []);
  return /*#__PURE__*/_jsx(GridPreferencePanelContext.Provider, {
    value: value,
    children: children
  });
}